export default __webpack_public_path__ + "static/media/layout-1.624ded4a.jpg";